export default __webpack_public_path__ + "media/images/backgrounds/fb-7a097a6ec5748eef2cf8020335dee9eb.jpg";